import { render } from "./TlbsOfferDiscountTilFebComponent.vue?vue&type=template&id=3c65886a&ts=true"
import script from "./TlbsOfferDiscountTilFebComponent.vue?vue&type=script&lang=ts"
export * from "./TlbsOfferDiscountTilFebComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__